import { render, staticRenderFns } from "./HRProcess.vue?vue&type=template&id=852f0054&scoped=true"
import script from "./HRProcess.vue?vue&type=script&lang=js"
export * from "./HRProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852f0054",
  null
  
)

export default component.exports